export const laboratoryOpinions = {
  NO_RESPONSES: 'Sin respuestas',
  EXCEEDED_EXPECTATIONS: 'Superó mis expectativas',
  POOR_EXPECTATIONS: 'Debajo de mis expectativas',
  ACHIEVED_EXPECTATIONS: 'Cumplió mis expectativas',
};
